<template>
  <div class="h-box">
    <div>
      <a @click="guide('')">首页</a>
      <a @click="guide('intro')">公司简介</a>
      <a @click="guide('dig')">数字化技术解决方案</a>
      <a @click="guide('info')">信息安全技术解决方案</a>
      <a @click="guide('contact')">联系我们</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    guide (hashName) {
      this.$router.push(`/${hashName}`)
    }
  }
}
</script>

<style scoped lang="scss">
.h-box{
  position: absolute;
  z-index: 99;
  top: 0;
  height: 72px;
  width: 100%;
  text-align: center;
  &:hover{
    background: rgba(0, 0, 0, 0.1);
  }
  // padding: 20px 19% 0 0;
  >div{
    height: 100%;
    line-height: 72px;
    width: 1080px;
    // width: 1080px;
    max-width: 74%;
    text-align: right;
    display: inline-block;
    a{
      color: #fff;
      font-size: 16px;
      margin-left: 56px;
      font-family: SourceHanSansCN-Regular;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      cursor: pointer;
      &:hover{
        text-decoration: none;
        color: #cce7ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HNavigation.vue